import { SiteHeader } from '../components/home/SiteHeader';
import { HeroSection } from '../components/home/HeroSection';
import { IntroductionSection } from '../components/home/IntroductionSection';
import { TrustSection } from '../components/home/TrustSection';
import { ServicesSection } from '../components/home/ServicesSection';
import { ReturnAffectifSection } from '../components/home/ReturnAffectifSection';
import { TestimonialsSection } from '../components/home/TestimonialsSection';
import { CitiesSection } from '../components/home/CitiesSection';
import { FaqSection } from '../components/home/FaqSection';
import { ContactSection } from '../components/home/ContactSection';
import { SiteFooter } from '../components/home/SiteFooter';
import { FloatingWhatsApp } from '../components/home/FloatingWhatsApp';
import { useContactActions } from '../hooks/useContactActions';

export default function Home() {
  const { handleWhatsAppClick, handleCallClick } = useContactActions('Bonjour Maître Diamma, je souhaite une consultation');
  return (
    <div className="site-theme min-h-screen bg-black text-white">
      <SiteHeader handleWhatsAppClick={handleWhatsAppClick} />
      <HeroSection handleWhatsAppClick={handleWhatsAppClick} handleCallClick={handleCallClick} />
      <IntroductionSection />
      <TrustSection />
      <ServicesSection handleWhatsAppClick={handleWhatsAppClick} />
      <ReturnAffectifSection handleWhatsAppClick={handleWhatsAppClick} />
      <TestimonialsSection handleWhatsAppClick={handleWhatsAppClick} />
      <CitiesSection handleWhatsAppClick={handleWhatsAppClick} />
      <FaqSection />
      <ContactSection handleWhatsAppClick={handleWhatsAppClick} handleCallClick={handleCallClick} />
      <SiteFooter handleWhatsAppClick={handleWhatsAppClick} />
      <FloatingWhatsApp handleWhatsAppClick={handleWhatsAppClick} />
    </div>
  );
}